import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

export const overviewCardStyles = StyleSheet.create({
	card: {
		backgroundColor: THEME.colors.background.light,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		padding: THEME.spacing.md,
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'space-between',
	},
	// Title + inline status chips grouped on the left; the edit actions stay on the right. Deliberately
	// nowrap: a wrapping flex container places items by their max-content width before shrinking any of
	// them, so a wide chip row would be bumped onto its own line instead of sitting beside the title.
	titleGroup: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		flexWrap: 'nowrap',
		gap: THEME.spacing.sm,
		minWidth: 0,
	},
	// The accessory shrinks and wraps internally so it stays on the title's line at any card width.
	headerAccessory: {
		display: 'flex',
		flex: '1 1 auto',
		minWidth: 0,
	},
	actionBar: {
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
});
